import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import {
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
  TextField,
  Typography,
} from '@material-ui/core';
import messages from 'messages';
import { editUsagePeriod } from '../../../api.js';
import { SnackbarVariant } from '../../../constants.js';
import { useSnackbar } from 'notistack';

export default function UsagePeriodForm({
  usagePeriod,
  handleClose,
  account,
  updateListCallback,
}) {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [formError, setFormError] = useState(false);

  const [formState, setFormState] = useState({
    usagePeriodStartDate: usagePeriod.Startdate.replace(
      /(\d{4})(\d{2})(\d{2})/g,
      '$1-$2-$3'
    ),
    usagePeriodEndDate: usagePeriod.EndDate.replace(
      /(\d{4})(\d{2})(\d{2})/g,
      '$1-$2-$3'
    ),
  });

  useEffect(() => {
    if (formError) {
      setDisableSubmit(true);
    } else {
      setDisableSubmit(false);
    }
  }, [formError]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    switch (name) {
      case 'usagePeriodStartDate': {
        setFormState({ ...formState, usagePeriodStartDate: value });
        const startDate = new Date(value);
        const endDate = new Date(formState.usagePeriodEndDate);
        const diffInDays = Math.ceil(
          (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
        );

        if (startDate > endDate || diffInDays > 395) {
          setFormError(true);
        } else {
          setFormError(false);
        }
        break;
      }

      case 'usagePeriodEndDate': {
        setFormState({ ...formState, usagePeriodEndDate: value });
        const startDate = new Date(formState.usagePeriodStartDate);
        const endDate = new Date(value);
        const diffInDays = Math.ceil(
          (endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24)
        );

        if (startDate > endDate || diffInDays > 395) {
          setFormError(true);
        } else {
          setFormError(false);
        }
        break;
      }

      default:
        break;
    }
  };

  const handleSubmit = () => {
    if (!disableSubmit) {
      const indexOfEndedUsagePeriod = account.sections.findIndex(
        (s) => s.id === usagePeriod.id
      );
      const editedUsagePeriod = {
        ...account.sections[indexOfEndedUsagePeriod],
        Startdate: formState.usagePeriodStartDate,
        EndDate: formState.usagePeriodEndDate,
      };

      account.sections = [editedUsagePeriod];

      editUsagePeriod(account)
        .then(() => {
          enqueueSnackbar(intl.formatMessage(messages.general_save_success), {
            variant: SnackbarVariant.SUCCESS,
          });
          updateListCallback();
        })
        .catch(() => {
          enqueueSnackbar(intl.formatMessage(messages.general_error), {
            variant: SnackbarVariant.ERROR,
          });
        });
      handleClose();
    }
  };

  return (
    <>
      <DialogTitle id="confirm-dialog-title">
        <Typography component="h3">
          {intl.formatMessage(messages.usagePeriod)}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          <Typography component="subtitle2">
            {intl.formatMessage(messages.usagePeriod_edit)}
          </Typography>
        </DialogContentText>
        <form>
          <TextField
            variant="standard"
            name="usagePeriodStartDate"
            label="Käyttöoikeusjakson alkupäivä"
            type="date"
            fullWidth
            value={formState.usagePeriodStartDate}
            onChange={handleChange}
            error={formError}
            helperText={formError ? 'Tarkista päivämäärät' : ''}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            variant="standard"
            name="usagePeriodEndDate"
            label="Käyttöoikeusjakson päättymispäivä"
            type="date"
            fullWidth
            value={formState.usagePeriodEndDate}
            onChange={handleChange}
            error={formError}
            helperText={
              formError
                ? 'Tarkista päivämäärät. Käyttöoikeusjakso ei saa ylittää 13 kk'
                : ''
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          {intl.formatMessage(messages.back)}
        </Button>
        <Button
          disabled={disableSubmit}
          variant="contained"
          size="small"
          color="primary"
          onClick={handleSubmit}
        >
          {intl.formatMessage(messages.send)}
        </Button>
      </DialogActions>
    </>
  );
}
